import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { TaskParametersForm, TaskParameterTypeEnum } from "@/components";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";

/**Маршруты */

export default /*#__PURE__*/_defineComponent({
  __name: 'project-tags-setting-page',
  setup(__props) {

const router = useRouter();

/**Компонент формы для настройки параметров */
const $taskParametersForm = ref<InstanceType<typeof TaskParametersForm>>();
/**Id проекта */
const projectId = computed(() => Number(router.currentRoute.value?.params.projectId));

/**Проверка наличия изменений в форме перед переходом */
router.beforeEach((to, from, next) => {
  if ($taskParametersForm.value?.haveChanges) {
    $taskParametersForm.value?.openLeaveConfirmation(() => {
      next();
    });
  } else {
    next();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TaskParametersForm), {
    ref_key: "$taskParametersForm",
    ref: $taskParametersForm,
    "separate-templates": "",
    type: _unref(TaskParameterTypeEnum).Tag,
    "entity-id": projectId.value
  }, null, 8, ["type", "entity-id"]))
}
}

})